import React from 'react';
import { FaRulerCombined, FaMoneyBillWave } from 'react-icons/fa';
import { formatMoney, formatNum } from '../../../services/cadastral.service';
import styles from '../../../styles/Cadastral.module.css';

function Block({ title, icon: Icon, children }) {
  return (
    <div className={styles.block}>
      <div className={styles.blockTitle}>
        <span className={styles.btIco}><Icon size={13} /></span>
        {title}
      </div>
      {children}
    </div>
  );
}

function Dl({ items, singleCol = false }) {
  return (
    <dl className={`${styles.dl} ${singleCol ? styles.one : ''}`}>
      {items.map(([label, val, className = ''], index) => (
        <div key={index}>
          <dt>{label}</dt>
          <dd className={styles[className] || className}>{val}</dd>
        </div>
      ))}
    </dl>
  );
}

export default function LandTab({ file }) {
  const landData = file.land;

  const measurements = [
    ['Superficie de terreno', `${formatNum(landData.area)} m²`, 'num'],
    ['Frente aproximado', `${formatNum(landData.frontage)} m`, 'num'],
    ['Fondo aproximado', `${formatNum(landData.depth)} m`, 'num'],
    ['Factor de mérito o demérito', landData.meritFactor.toFixed(6), 'num']
  ];

  const landValueCodeDetails = [
    ['Código de valor de suelo', landData.valueCode.code, 'mono'],
    ['Valor unitario de suelo 2026', `${formatMoney(landData.valueCode.unitValue)} / m²`, 'num'],
    ['Tramo de valor (calle / de / a)', landData.valueCode.stretch]
  ];

  return (
    <div className={styles.tabContentFade}>
      <Block title="A) Valor del terreno" icon={FaRulerCombined}>
        <p className={styles.formula}>
          Valor del Terreno = Superficie × Valor Unitario × Factor de mérito o demérito
        </p>
        <div className={styles.tblWrap}>
          <table className={styles.tbl}>
            <thead>
              <tr>
                <th>Superficie</th>
                <th>Valor unitario</th>
                <th className={styles.c}>Factor de mérito o demérito</th>
                <th className={styles.r}>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={styles.r}>{formatNum(landData.area)} m²</td>
                <td className={styles.r}>{formatMoney(landData.unitValue)}</td>
                <td className={styles.c}>{landData.meritFactor.toFixed(6)}</td>
                <td className={styles.r}>{formatMoney(landData.totalValue)}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={3}>SUBTOTAL</td>
                <td className={styles.r}>{formatMoney(landData.totalValue)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </Block>

      <Block title="Medidas y colindancias" icon={FaRulerCombined}>
        <Dl items={measurements} />
      </Block>

      <Block title="Parámetro de valor de suelo" icon={FaMoneyBillWave}>
        <Dl items={landValueCodeDetails} singleCol />
      </Block>

      <div className={styles.stateDetail}>
        Valores conforme al <strong>Decreto por el que se aprueban las Tablas de Valores Unitarios de Suelo y
        Construcciones del Municipio de Querétaro, Qro., para el Ejercicio Fiscal 2026</strong>, publicado en el
        Periódico Oficial "La Sombra de Arteaga" el 09 de diciembre de 2025.
      </div>
    </div>
  );
}